import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SignalSection } from '../components/SignalSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-261">
      <HeroSection data-id="element-262" />

      <SignalSection data-id="element-263" />

      <ProtocolSection data-id="element-264" />

      <BenefitsSection data-id="element-265" />
      <PainSection data-id="element-266" />

      <TestimonialsSection data-id="element-267" />

      <DifferenceSection data-id="element-268" />

      

      <ForWhoSection data-id="element-269" />

      <BibliotecaSection data-id="element-270" />

      <OfferSection data-id="element-271" />

      <AboutSection data-id="element-272" />

      <FAQSection data-id="element-273" />

      <FinalCTASection data-id="element-274" />
    </main>;
}